/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {CustomerContactsResourceService} from '@well/resource-services';

@Injectable({
  providedIn: 'root'
})
export class ContactAutocompleteService {

  constructor(private customerContactsResourceService: CustomerContactsResourceService) { }

  findAll(customerUuid: string, query: any): Observable<any> {
    return this.customerContactsResourceService.findContactDTOSuggestions(customerUuid, query);
  }

}
